import { useCallback } from 'react';

import { Input } from '@/components/form/Input';
import { MoneyInputMask } from '@/components/form/MoneyInputMask';
import { SwitchableSection } from '@/components/ui/SwitchableSection';
import useProductStore, { productStore } from '@/stores/productStore';

export const Conditions = () => {
  const payment = useProductStore(d => d.payment);

  const store = productStore.getState();

  const toggleTrial = useCallback(() => {
    store.setFields({
      payment: {
        ...payment,
        trialEnabled: !payment.trialEnabled
      }
    });
  }, [store, payment]);

  const toggleActivationFee = useCallback(() => {
    store.setFields({
      payment: {
        ...payment,
        activationFeeEnabled: !payment.activationFeeEnabled
      }
    });
  }, [store, payment]);

  return (
    <div className='flex flex-col gap-4'>
      <SwitchableSection
        onChange={toggleTrial}
        isActive={!!payment.trialEnabled}
        title='Período de teste'
        description='Permite que o cliente teste o produto gratuitamente por um tempo.'
      >
        <Input label='Quantidade de dias para teste' id='trialDays' type='number' name='trialDays' />
      </SwitchableSection>
      <SwitchableSection
        onChange={toggleActivationFee}
        isActive={!!payment.activationFeeEnabled}
        title='Taxa de adesão '
        description='Cobra um valor inicial antes de começar a assinatura.'
      >
        <MoneyInputMask label='Valor da adesão' id='activationFeeValue' prefix='R$' name='activationFeeValue' />
      </SwitchableSection>
    </div>
  );
};
